import React, { useRef } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { connect } from 'react-redux'
import { Circles } from 'react-loader-spinner'
import { useEffect,useState } from 'react'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { restrictInputValues,isPermissionExist,sortPortalPermissionByKey,restrictSpecialChar, handleKeyPressRestrictLeadingTrailingSpace } from '../../utils/helper'
import CardConnectTokenizer from '../walletButtons/CardTokenizer'
const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
const expirymask = createDefaultMaskGenerator('99/99')

function AddCardModal(props) {
    const { isModalOpen, setModal, modalName, isLoading, isEdit, error, handleCardChange, 
        handleExpiryChange, partnerDetails, handleSubmit, expiry, card, payload, errorMessage, 
        setErrorMessage, setError, setCard, setExpiry, handleInputFieldsData, handleisDefault, 
        cardError, cardList, isFiservGateway, setFiservToken, setIframeErrorMsg, faciltyData, tokenRef } = props
    const [accessPermissions, setAccessPermissions] = useState('')
// console.log('partnerDetails>',partnerDetails)
    const firstInputRef = useRef(null)
    useEffect(() => {
        setErrorMessage('')
        setError(false)
        setCard('')
        setExpiry('')
    }, [isModalOpen])

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])

    useEffect(() => {
        if (firstInputRef?.current) {
          firstInputRef.current.focus()
        }
    }, [isModalOpen])

    return (
        <>
            <Modal size="lg" show={isModalOpen} onHide={() => setModal(false)} aria-labelledby="example-modal-sizes-title-sm" >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm"> {modalName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isFiservGateway ? 
                            // Fiserv Gateway - Show iframe
                            <div>
                                {/* Fiserv iframe for card details */}
                                <CardConnectTokenizer
                                    setToken={setFiservToken}
                                    setIframeErrorMessage={setIframeErrorMsg}
                                    faciltyPaymentDetails={faciltyData?.facility_payment_details || {}}
                                    tokenRef={tokenRef}
                                />
                                <div className="col-sm-4 ">
                                    <div className="mb-3">
                                        <div className='switch-wrap'>
                                        <input type={'checkbox'} id='defaultbtn' value={payload?.is_default} className=" form-check-input" name='defaultbtn' onChange={handleisDefault} checked={payload?.is_default == 1 || cardList?.length == 0}/>
                                            <label htmlFor="defaultbtn" className='fw-normal ps-2' > Mark as default</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        : <div>
                        <div className="row">
                            <div className="col-sm-6  mb-3">
                                <label className="form-label">Name on Card <span className='text-danger'>*</span></label>
                                <input
                                    type="text"
                                    autoComplete="off"
                                    maxLength={20}
                                    minLength={1}
                                    className="form-control"
                                    name="name_on_card"
                                    value={payload?.name_on_card}
                                    placeholder="Name on Card"
                                    onChange={handleInputFieldsData}
                                    required={true}
                                    ref={firstInputRef}
                                    onKeyPress={(e) => handleKeyPressRestrictLeadingTrailingSpace(e)}
                                />
                                <span className="form-text text-danger h-40">{error && !payload?.name_on_card ? 'This field is required' : ''}</span>
                            </div>
                            <div className="col-sm-6  mb-3">
                                <label className="form-label">Card Number <span className='text-danger'>*</span></label>
                                <MaskedInput
                                    maskGenerator={cardnumbermask}
                                    value={card}
                                    type="text"
                                    autoComplete="off"
                                    name="card_number"
                                    id="card_number"
                                    required={true}
                                    pattern="[0-9 ]{18,19}"
                                    maxLength='19'
                                    minLength='15'
                                    title="Card no. should be 15-16 digit numberic"
                                    className="form-control"
                                    onChange={handleCardChange}
                                    onInvalid={e => e.target.setCustomValidity('Please enter a valid card number')}
                                    onInput={e => e.target.setCustomValidity('')}
                                    placeholder="Card Number"
                                    onKeyPress={(e) => handleKeyPressRestrictLeadingTrailingSpace(e)}
                                />
                                <span className="form-text text-danger h-40">{error && !payload?.card_number ? 'This field is required' : (payload?.card_number.length && payload?.card_number.length < 15) ? 'Please enter a valid card number' : ''}</span>
                            </div>
                            <div className="col-sm-4  mb-3">
                                <label className="form-label">Expiration Date <span className='text-danger'>*</span></label>
                                <MaskedInput
                                    maskGenerator={expirymask}
                                    value={expiry}
                                    type="text"
                                    autoComplete="off"
                                    name="expiration_date"
                                    id="expiration_date"
                                    required={true}
                                    pattern="[0-9 ]{4}"
                                    maxLength='5'
                                    minLength='4'
                                    title="Enter a valid expiry date"
                                    className="form-control"
                                    onChange={handleExpiryChange}
                                    onInvalid={e => e.target.setCustomValidity('Please enter a valid expiry date')}
                                    onInput={e => e.target.setCustomValidity('')}
                                    placeholder="MM/YY"
                                    onKeyPress={(e) => handleKeyPressRestrictLeadingTrailingSpace(e)}
                                />
                                <span className="form-text text-danger h-40">{error && !payload?.expiration_date ? 'This field is required' : (error && cardError) ? cardError : ''}</span>
                            </div>
                            <div className="col-sm-4  mb-3">
                                <label className="form-label">CVV <span className='text-danger'>*</span></label>
                                <input
                                    onChange={handleInputFieldsData}
                                    autoComplete="off"
                                    className="form-control"
                                    id="security_code"
                                    maxLength="4"
                                    name="security_code"
                                    value={payload.security_code}
                                    placeholder="CVV / Security Code"
                                    type="password"
                                    required=""
                                    onKeyPress={(e) => handleKeyPressRestrictLeadingTrailingSpace(e)}
                                />
                                <span className="form-text text-danger h-40">{error && !payload?.security_code ? 'This field is required' : ''}</span>
                            </div>
                            <div className="col-sm-4 ">
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Zip Code</label>
                                    <input
                                        onChange={handleInputFieldsData}
                                        className="form-control "
                                        maxLength="6"
                                        autoComplete="new password"
                                        minLength="5"
                                        name="zip_code_on_card"
                                        value={payload?.zip_code_on_card}
                                        pattern="[0-9]{5,6}"
                                        placeholder="Billing Address Zip Code"
                                        type="text"
                                        onPaste={(e) => {
                                            e.preventDefault()
                                            return false
                                        }}
                                        onKeyPress={(e) => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? restrictSpecialChar(e):restrictInputValues(e)}

                                        // onKeyPress={(e) => restrictInputValues(e)}
                                    />
                                    <div className="form-text text-danger h-40">**Mandatory for Amex Cards only</div>
                                    <span className="form-text text-danger h-40">{error && (payload?.zip_code_on_card && payload?.zip_code_on_card.length<5) ? 'Please enter a valid zip code' : ''}</span>
                                </div>
                            </div>
                            <span className="form-text text-danger h-40">{(errorMessage) ? errorMessage : ''}</span>

                            <div className="col-sm-4 ">
                                <div className="mb-3">
                                    <div className='switch-wrap'>
                                    <input type={'checkbox'} id='defaultbtn' value={payload?.is_default} className=" form-check-input" name='defaultbtn' onChange={handleisDefault} checked={payload?.is_default == 1 || cardList?.length == 0}/>
                                        <label htmlFor="defaultbtn" className='fw-normal ps-2' > Mark as default</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-primary d-flex" type="submit" data-bs-dismiss="modal" onClick={handleSubmit}>{isEdit ? 'Update Card' : 'Save Card'}{isLoading && error ? <span className=' ms-2'><Circles
                        height="20"
                        width="20"
                        color="#ffffff"
                        ariaLabel="circles-loading"
                        visible={true}
                    /></span> : null}</Button>
                    {/* <Button  className="btn btn-primary" onClick={handleSubmit} style={{ float: 'right' }}>Submit</Button> */}
                </Modal.Footer>
            </Modal>
        </>
    )
}

AddCardModal.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    modalName: PropTypes.string,
    isModalOpen: PropTypes.bool,
    setModal: PropTypes.func,
    isLoading: PropTypes.bool,
    isEdit: PropTypes.bool,
    error: PropTypes.bool,
    handleCardChange: PropTypes.func,
    handleExpiryChange: PropTypes.func,
    handleSubmit: PropTypes.func,
    expiry: PropTypes.string,
    card: PropTypes.string,
    payload: PropTypes.object,
    errorMessage: PropTypes.string,
    setErrorMessage: PropTypes.func,
    setError: PropTypes.func,
    setCard: PropTypes.func,
    setExpiry: PropTypes.func,
    handleInputFieldsData: PropTypes.func,
    handleisDefault: PropTypes.func,
    partnerDetails: PropTypes.object,
    cardError: PropTypes.string,
    cardList: PropTypes.object,
    isFiservGateway: PropTypes.bool,
    setFiservToken: PropTypes.func,
    setIframeErrorMsg: PropTypes.func,
    faciltyData: PropTypes.object,
    tokenRef: PropTypes.object,
}

AddCardModal.defaulProps = {
    dispatch: noop,
    loader: PropTypes.bool,
    modalName: PropTypes.string,
    isModalOpen: PropTypes.bool,
    setModal: PropTypes.func,
    isLoading: false,
    isEdit: false,
    error: false,
    handleCardChange: noop,
    handleExpiryChange: noop,
    handleSubmit: noop,
    expiry: '',
    card: '',
    payload: {},
    errorMessage: '',
    setErrorMessage: noop,
    setError: noop,
    setCard: noop,
    setExpiry: noop,
    handleInputFieldsData: noop,
    handleisDefault: noop,
    partnerDetails: EMPTY_OBJECT,
    cardError: '',
    cardList: EMPTY_ARRAY,
    isFiservGateway: false,
    setFiservToken: noop, 
    setIframeErrorMsg: noop,
    faciltyData: EMPTY_OBJECT,
    tokenRef: EMPTY_OBJECT,
}

function mapStateToProps({ state,PartnerReducer }) {
    return { state,
        partnerDetails: PartnerReducer?.partnerDetails?.data,
     }
}


export default connect(mapStateToProps)(AddCardModal)
